import {
  ADDITIONAL_FIELD_FORMAT_TYPE,
  APIStatus,
  ActionType,
  CampaignType,
  DISPLAY_ADDITIONAL_FIELD_FORMAT_TYPE,
  LanguageConfig,
  SESSION_KEYS,
  TICKET_CAMPAIGN_OTHER_INFORMATION_QUESTION_TYPE,
  RECURRING_OFFSET_TYPE,
  TARGET_CUSTOMER_TYPE,
  MessageBackendChannel,
  MessagePushAndInboxSelector,
  showCampaignPublishChannelSelector,
  ApprovalStatus,
  EarningRuleType,
  COUPON_TYPES,
  COUPON_SET_MEDIUM,
  EarningRuleTypeKey,
  EarningRuleRewardType,
  COUPON_SET_TYPES,
  COUPON_CODE_TYPE,
} from 'config/CustomEnums';
import { createModel } from 'models/BaseModel';
import { getFormatedStatus, getTypeDisplay, getOtherInformationsForInputValue } from 'models/CampaignListModel';
import { CREATE_CAMPAIGN_CATEGORY_FAILD, CREATE_CAMPAIGN_CATEGORY_SUCCESS } from 'models/CreateCampaignCategoryModel';
import { apiWithResponseHandle, loading } from 'models/LoadingUtil';
// import { CampaignErrorHandleField } from 'components/campaign/campaignCreation/CreateCampaignHandleError';
import { defaultStep, getNewStepConfig } from 'models/StepBarUtil';
import {
  CreateTempCampaign,
  createCampaign,
  deleteCampaign,
  duplicateCampaign,
  getCampaign,
  getOneCoupon,
  getOneEarningRule,
  rejectPendingForApprovalCampaign,
  updateApprovalStatus,
  updateCampaign,
  createDraftCampaign,
  updateDraftCampaign,
  publishCampaignV2,
  publishCampaignWithExistEarningRule,
  CreateTempCampaignV2,
} from 'services/CampaignAPIHelper';
import { parseChannels } from "models/CreateMessageModel"



import { addDomainToImage, convertPKToId, createAction, delay, getDisplayLastModifiedBy, getFileNameFromUrl, getImageImage, getObjectFromSessionStorage, removeFromSessionStorage, saveToSessionStorage } from 'utils';
import { getDetailPageDisplayLastModifiedDate } from 'utils/TimeFormatUtil';
import { parseDetailMessage } from 'models/MessageListModel'
import { cleanEarningRuleCreationData, parseEarningRule } from './CreateEarningRulesModel';
import { assembleDetailBanner, getBannerDataForCampaign, getBannerForCreateOrUpdate } from './HomeBannersModel';
import { returnDefaultValueWhileEmpty } from 'utils/StringUtil';
import { couponSetFieldPrefix, getCouponSetMedium } from 'containers/engagement/campaignStreamline/CreateCampaignCouponPageConfig';
import { cleanCouponTemplateFormData } from './CreateCouponModel';
import { parseCouponSet } from './CouponUtil';

export const sessionDataKey = {
  objectKey: SESSION_KEYS.CREATE_CAMPAIGN_SESSION_KEY,
  stepEndKey: SESSION_KEYS.CREATE_CAMPAIGN_END_SESSION_KEY,
  origionalData: SESSION_KEYS.CREATE_CAMPAIGN_ORIGIN_DATA_SESSION_KEY,
};

export const stampSessionDataKey = {
  objectKey: SESSION_KEYS.CREATE_STAMP_CAMPAIGN_SESSION_KEY,
  stepEndKey: SESSION_KEYS.CREATE_STAMP_CAMPAIGN_END_SESSION_KEY,
  origionalData: SESSION_KEYS.CREATE_STAMP_CAMPAIGN_ORIGIN_DATA_SESSION_KEY,
};

export const generalMessageCampaignSessionDataKey = {
  objectKey: SESSION_KEYS.CREATE_GENERAL_MESSAGE_CAMPAIGN_SESSION_KEY,
  stepEndKey: SESSION_KEYS.CREATE_GENERAL_MESSAGE_CAMPAIGN_END_SESSION_KEY,
  origionalData: SESSION_KEYS.CREATE_GENERAL_MESSAGE_CAMPAIGN_ORIGIN_DATA_SESSION_KEY,
};
export const ticketCampaignSessionDataKey = {
  objectKey: SESSION_KEYS.CREATE_TICKET_CAMPAIGN_SESSION_KEY,
  stepEndKey: SESSION_KEYS.CREATE_TICKET_CAMPAIGN_END_SESSION_KEY,
  origionalData: SESSION_KEYS.CREATE_TICKET_CAMPAIGN_ORIGIN_DATA_SESSION_KEY,
};


export const GENERAL_TYPE = {
  customerGroup: 'Customer list',
  segment: 'Segment',
  level: 'Level',
};

export const publishChannelList = [
  { pk: 'App', name: 'App' },
  { pk: 'Website', name: 'Website' },
];

export const LINK_COUPON_STRING = 'linkedCouponInfo';

export const isShowCouponRelated = (campaignType) => {
  return campaignType === CampaignType.couponsCampaign;
};

export const isShowEarningRuleRelated = (campaignType) => {
  return campaignType === CampaignType.earningRulesCampaign;
};

const stepNames = ['Type', 'Content', 'Properties', 'Preview'];
const stampStepNames = ['Content', 'Properties', 'Preview'];
const generalMessageStepNames = ['Content', 'Properties', 'Preview'];

export const saveDataToSessionStorage = (data = {}, isStamp = false, campaignType) => {
  let objKey = sessionDataKey.objectKey
  if (isStamp) {
    objKey = stampSessionDataKey.objectKey
  } else if (campaignType === CampaignType.generalMessageCampaign) {
    objKey = generalMessageCampaignSessionDataKey.objectKey
  } else if (campaignType === CampaignType.ticketCampaign) {
    objKey = ticketCampaignSessionDataKey.objectKey
  } 
  saveToSessionStorage(
    objKey,
    data,
  );
};

export const removeDataFromSessionStorage = (isStamp = false, campaignType) => {
  let objKey = sessionDataKey.objectKey
  if (isStamp) {
    objKey = stampSessionDataKey.objectKey
  } else if (campaignType === CampaignType.generalMessageCampaign) {
    objKey = generalMessageCampaignSessionDataKey.objectKey
  } else if (campaignType === CampaignType.ticketCampaign) {
    objKey = ticketCampaignSessionDataKey.objectKey
  } 
  removeFromSessionStorage(objKey);
};

export const isTicketCampaignOtherInformationQuestionShowOption = ({
  fieldFormat,
}) =>
  [
    ADDITIONAL_FIELD_FORMAT_TYPE.DROPDOWN,
    ADDITIONAL_FIELD_FORMAT_TYPE.SINGLE_CHOICES,
    ADDITIONAL_FIELD_FORMAT_TYPE.MULTI_CHOICES,
  ].includes(fieldFormat);


function getTranlationDataForCreateCampaign({
  campaign,
  language,
  update,
  hideInFrontend = false,
}) {
  let languageField = {};
  const translation = campaign?.translations?.[language] || {};
  if (language !== LanguageConfig.english) {
    languageField = {
      language: language,
    };
    if (translation.pk && update) {
      languageField['id'] = translation.pk;
    }
  }

  let result = {
    ...languageField,
    shortDescription: translation.shortDescription,
    name: translation.generalName,
    instructionSectionTitle: translation.instructionSectionTitle,
    instructionSectionContent: translation.instructionSectionContent,
    detailSectionTitle: translation.detailSectionTitle,
    detailSectionContent: translation.detailSectionContent,
    coverPhoto: getImageImage(translation.coverPhoto) || null,
    detailPhoto1: getImageImage(translation.detailPhotos?.[0]) || null,
    detailPhoto2: getImageImage(translation.detailPhotos?.[1]) || null,
    detailPhoto3: getImageImage(translation.detailPhotos?.[2]) || null,
    detailPhoto4: getImageImage(translation.detailPhotos?.[3]) || null,
    squareCoverPhoto: getImageImage(translation.squareCoverPhoto) || null,
  };

  if (hideInFrontend) {
    result = {
      ...result,
      shortDescription: null,
      instructionSectionTitle: null,
      instructionSectionContent: null,
      detailSectionTitle: null,
      detailSectionContent: null,
      coverPhoto: null,
      detailPhoto1: null,
      detailPhoto2: null,
      detailPhoto3: null,
      detailPhoto4: null,
      squareCoverPhoto: null,
    }
  }

  return result;
}

function getRelatedTicket(campaign) {
  const ticketCampaignTimeSlots = campaign?.ticketCampaignTimeSlots || [];
  if (ticketCampaignTimeSlots?.length < 1) {
    return [];
  }

  const getTicketTranslations = (translations) => {
    const resTranslations = [];
    Object.keys(translations || {}).forEach((language) => {
      if (language === LanguageConfig.english) {
        return;
      }
      resTranslations.push({
        language,
        ...(translations?.[language]?.pk
          ? { id: translations?.[language].pk }
          : {}),
        timeSlot: translations?.[language]?.timeSlot,
      });
    });
    return resTranslations;
  };

  return ticketCampaignTimeSlots?.map((item, index) => ({
    slotNumber: index + 1,
    couponTemplate: item?.couponSet?.pk,
    timeSlot: item?.translations?.[LanguageConfig.english]?.timeSlot,
    translations: getTicketTranslations(item?.translations),
  }));
}

function gerOtherInformations(campaign) {
  const customerProfileFields = campaign?.showCustomerProfileFields || [];
  const customerAdditionalFields = campaign?.showCustomerAdditionalFields || [];
  const additionalQuestion = campaign?.additionalQuestion || [];
  return [
    ...customerProfileFields?.map((field) => ({
      questionType:
        TICKET_CAMPAIGN_OTHER_INFORMATION_QUESTION_TYPE.CUSTOMER_PROFILE_FIELD,
      customerProfileField: field.pk,
    })),
    ...customerAdditionalFields?.map((field) => ({
      questionType:
        TICKET_CAMPAIGN_OTHER_INFORMATION_QUESTION_TYPE.CUSTOMER_ADDITIONAL_DATA_FIELD,
      customerAdditionalDataField: field.pk,
    })),
    ...additionalQuestion?.map((field) => ({
      questionType:
        TICKET_CAMPAIGN_OTHER_INFORMATION_QUESTION_TYPE.ADDITION_QUESTION,
      questionNameAndHint:
        field?.translations?.[LanguageConfig.english]?.fieldName,
      questionFormat: field?.fieldFormat?.value?.value,
      isOptional: field?.isOptional || false,
      translations: Object.keys(field?.translations || {})?.map((language) => ({
        language,
        ...(field?.translations?.[language]?.pk
          ? { id: field?.translations?.[language]?.pk }
          : {}),
        questionNameAndHint: field?.translations?.[language]?.fieldName,
      })),
      options: isTicketCampaignOtherInformationQuestionShowOption({
        fieldFormat: field?.fieldFormat?.value?.value,
      })
        ? field?.fieldOptions?.map((optionTranslations) => ({
          id: null,
          optionName: optionTranslations?.[LanguageConfig.english] || '',
          translations: Object.keys(optionTranslations || {})?.map(
            (language) => ({
              language,
              optionName: optionTranslations?.[language] || '',
            }),
          ),
        }))
        : [],
    })),
  ];
}

const transformDataFromCampaignToEarningRule = (campaign, earningRule= {}, update, syncTranslation=true) => {
  const translations = {};
  if (syncTranslation) {
    (Object.entries(campaign.translations) || []).forEach(([lang, languageTranslation]) => {
      translations[lang] = {
        generalName: languageTranslation?.generalName,
        instructionSectionTitle: languageTranslation?.instructionSectionTitle,
        instructionSectionContent: languageTranslation?.instructionSectionContent,
        detailSectionTitle: languageTranslation?.detailSectionTitle,
        detailSectionContent: languageTranslation?.detailSectionContent,
      }
    })
  }
  return {
    ...earningRule,
    isAlwaysActivePeriod: campaign.isAlwaysActivePeriod,
    activeStartDate: campaign.activeStartDate,
    activeEndDate: campaign.activeEndDate,
    activePeriodValues: campaign.activePeriodValues,
    activeWeekday: campaign.activeWeekday,
    isExclusive: campaign.isExclusive || false,
    targetCustomerType: campaign.generalType,
    dynamicSegments: campaign.dynamicSegments,
    staticSegments: campaign.staticSegments,
    targetedLevels: campaign.levels,
    excludeBlacklistSegment: campaign.excludeBlacklistSegment,
    blacklistSegments: campaign.blacklistSegments,
    isInBirthMonth: earningRule.type === EarningRuleType.generalPurchase && campaign.isBirthdayRecurringCampaign,
    recurringDate: {
      ...(campaign.recurringDate || {}),
      pk: update ? (earningRule.recurringDate?.pk || undefined) : undefined,
    },
    emptyLimits: !earningRule.haveLimitsField,
    translations: syncTranslation ? translations : earningRule?.translations,
    selectedStores: earningRule.haveEligibleStores ? earningRule.selectedStores : [],
  }
}

const transformDataFromCampaignToCouponTemplate = (campaign) => {
  const couponTemplate = campaign?.campaignCouponTemplate || {};

  const selectedStores = couponTemplate?.selectedStores || []
  const mediumType = getCouponSetMedium(selectedStores)
  const {
    onlineCouponSetType,
    offlineCouponSetType,
    offlineRedemptionMethod,
    onlineRedemptionMethod,
    isDifferentCodeForOnlineOffline
  } = couponTemplate
  const useOnlineOfflineData = mediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE && !isDifferentCodeForOnlineOffline

  let couponTemplateTranslation = couponTemplate?.translations || {}
  const campaignType = campaign?.campaignType
  const campaignTranslations = campaign?.translations || {}
  const couponTemplateContentSameAsCampaign = couponTemplate?.couponSetContentSameAsCampaign
  if (campaignType === CampaignType.couponsCampaign && couponTemplateContentSameAsCampaign) {
    couponTemplateTranslation = {};
    (Object.entries(campaignTranslations) || []).forEach(([lang, languageTranslation]) => {
      couponTemplateTranslation[lang] = {
        ...languageTranslation,
        name: languageTranslation?.generalName
      }
    })
  }
  return {
    ...couponTemplate,
    type: COUPON_TYPES.NORMAL,
    mediumType,
    customerOnlineOfflineSelectionBehavior: couponTemplate?.customerStoreSelectionBehavior,
    couponStores: { stores: selectedStores },
    onlineCouponSetType: useOnlineOfflineData
      ? couponTemplate?.onlineAndOfflineCouponSetType
      : onlineCouponSetType,
    offlineCouponSetType: useOnlineOfflineData
      ? couponTemplate?.onlineAndOfflineCouponSetType
      : offlineCouponSetType,
    offlineRedemptionMethod: useOnlineOfflineData
      ? couponTemplate?.onlineAndOfflineRedemptionMethod
      : offlineRedemptionMethod,
    onlineRedemptionMethod: useOnlineOfflineData
      ? couponTemplate?.onlineAndOfflineRedemptionMethod
      : onlineRedemptionMethod,
    translations: couponTemplateTranslation,
  }
}



export const getShowDisplayInFrontend = (campaignType, earningRuleType) => {
  return campaignType === CampaignType.earningRulesCampaign
    && [
      EarningRuleType.generalPurchase,
      EarningRuleType.newMember,
      EarningRuleType.birthday,
      EarningRuleType.levelUpgrade,
      EarningRuleType.fillingForm,
    ].includes(earningRuleType)
};

export const getHideInFrontend = ({ getValues }) => {
  const [
    campaignType,
    earningRuleType,
    displayInFrontend,
  ] = getValues([
    'campaignType',
    'linkedEarningRules.type',
    'displayInFrontend',
  ]);
  const showDisplayInFrontend = getShowDisplayInFrontend(campaignType, earningRuleType);
  const hideInFrontend = showDisplayInFrontend && !displayInFrontend && showDisplayInFrontend !== undefined;

  return hideInFrontend;
};

function getDataForCreateCampaign(campaign, update) {
  const categories = campaign.categories?.map((category) => category.pk);
  let earningRule = {};
  let coupon = {};
  let task = {};
  let rewards = {};
  let icons = {};
  let ticketCampaignFields = {};

  if (campaign.campaignType === CampaignType.couponsCampaign) {
    coupon = {
      couponCampaignTypeCouponTemplate: campaign.linkedCoupon.pk,
      couponCampaignTypeShouldShowCouponStock: campaign.displayOverLimit,
      couponCampaignTypeOverallLimit:
        campaign.overallLimit || (campaign.overallLimit === 0 ? 0 : null),
      couponCampaignTypePerHeadLimit: campaign.perHeadLimit || null,
      couponCampaignTypeRequiredPoints: campaign.requiredPoints,
    };
  }
  if (campaign.campaignType === CampaignType.earningRulesCampaign) {
    earningRule = {
      earningCampaignTypeEarningRule: campaign.linkedEarningRules.pk,
    };
  }
  if (campaign.campaignType === CampaignType.stampCampaign) {
    task = {
      stampTasks: campaign.stampLinkedEarningRules.map((item, index) => ({
        id: item.pk,
        displayOrder: index,
        earningRule: item.pk,
      })),
    };
    rewards = {
      stampCampaignRewards: campaign.stampRewards.map((item) => ({
        pk: item.pk,
        id: item.id,
        rewardType: item.rewardType,
        quantity: item.quantity,
        requiredStamps: item.requiredStamps,
        couponTemplate:
          item.rewardType === 'COUPON' ? item.linkedCoupon?.pk : null,
      })),
    };
    if (campaign.useUploadStampIcons) {
      icons = {
        stampCampaignTypeEmptySlotStampImage:
          getImageImage(campaign.stampCampaignTypeEmptySlotStampImage) || null,
        stampCampaignTypeAcquiredStampImage:
          getImageImage(campaign.stampCampaignTypeAcquiredStampImage) || null,
        stampCampaignTypeEmptyGiftSlotImage:
          getImageImage(campaign.stampCampaignTypeEmptyGiftSlotImage) || null,
        stampCampaignTypeCollectedGiftImage:
          getImageImage(campaign.stampCampaignTypeCollectedGiftImage) || null,
      };
    } else {
      icons = {
        stampCampaignTypeEmptySlotStampImage: null,
        stampCampaignTypeAcquiredStampImage: null,
        stampCampaignTypeEmptyGiftSlotImage: null,
        stampCampaignTypeCollectedGiftImage: null,
      };
    }
  }

  if (campaign.campaignType === CampaignType.ticketCampaign) {
    ticketCampaignFields = {
      ticketCampaignTypeShouldShowCouponStock: campaign.displayOverLimit,
      ticketCampaignTypePerHeadLimit: campaign.perHeadLimit || null,
      ticketCampaignEnableOtp: campaign?.enableOtp || false,
      ticketCampaignShouldFillOtherInformation:
        campaign?.fillOtherInfomation || false,
      relatedTickets: getRelatedTicket(campaign),
      otherInformations: campaign?.fillOtherInfomation
        ? gerOtherInformations(campaign)
        : [],
    };
  }

  const formattedTranslation = getTranlationDataForCreateCampaign({
    campaign,
    language: LanguageConfig.english,
    update,
  });

  const otherTranslations = [];
  Object.keys(campaign?.translations || {}).forEach((language) => {
    if (language === LanguageConfig.english) {
      return;
    }
    otherTranslations.push(
      getTranlationDataForCreateCampaign({ campaign, language, update }),
    );
  });

  const blackoutPeriod = (campaign.activePeriodValues ?? [])
    .filter((item) => {
      return !!item?.startDate && !!item?.endDate;
    })
    .map((item) =>
      update ? item : { startDate: item.startDate, endDate: item.endDate },
    );
  const blackoutWeekday = campaign.activeWeekday;
  const isGPCampaign = campaign.campaignType === 'GENERAL_MESSAGE_CAMPAIGN';
  console.log("finallyCampaign:", campaign)
  const recurringDateInfo = campaign?.recurringDate
  if (recurringDateInfo?.pk) {
    recurringDateInfo.id = recurringDateInfo.pk
    delete recurringDateInfo.pk;
  }
  const result = {
    type: campaign.campaignType,
    categories: categories,
    isFeatured: campaign.isFeatured || false,
    isExclusive: campaign.isExclusive || false,
    excludeBlacklistSegment: campaign?.excludeBlacklistSegment || false,
    targetedBlacklistSegments: campaign?.excludeBlacklistSegment
      ? campaign?.blacklistSegments?.map((item) => item.pk) || []
      : [],
    brand: campaign.linkedBrand?.pk || null,
    stores: campaign.linkedStores?.map((item) => item.pk),
    applyCoverPhotoToAllLanguage: campaign.applyCoverPhotoToAllLanguage,
    applyDetailPhotosToAllLanguage: campaign.applyDetailPhotosToAllLanguage,
    applySquareCoverPhotoToAllLanguage:
      campaign.applySquareCoverPhotoToAllLanguage,
    blackoutPeriod: isGPCampaign ? [] : blackoutPeriod,
    blackoutWeekday: isGPCampaign ? [] : blackoutWeekday,
    translations: otherTranslations,
    ...showCampaignPublishChannelSelector
      ? {
        publishChannel: [
          CampaignType.couponsCampaign,
          CampaignType.earningRulesCampaign,
          CampaignType.ticketCampaign,
        ].includes(campaign.campaignType)
          ? JSON.stringify(campaign.publishChannel?.map((item) => item.pk))
          : JSON.stringify(publishChannelList.map((item) => item.pk)),
      } : {},
    triggerPriority:
      campaign.campaignType === CampaignType.stampCampaign
        ? campaign.executionPriority
        : null,
    ...formattedTranslation,
    ...coupon,
    ...earningRule,
    ...task,
    ...rewards,
    ...icons,
    ...ticketCampaignFields,
    malls: campaign.malls?.map((mall) => mall.pk) || [],
    recurringDate: recurringDateInfo,
    isBirthdayRecurringCampaign: campaign.isBirthdayRecurringCampaign,
  };

  const targetType = campaign.generalType;
  if (campaign.isExclusive && targetType) {
    let segments = [];
    let levels = [];
    const levelsLength = campaign.levels?.length;
    if (targetType === TARGET_CUSTOMER_TYPE.DYNAMIC_SEGMENT) {
      segments = campaign?.dynamicSegments?.map((segment) => segment.pk) || [];
    } else if (targetType === TARGET_CUSTOMER_TYPE.STATIC_SEGMENT) {
      segments = campaign?.staticSegments?.map((segment) => segment.pk) || [];
    } else if (targetType === TARGET_CUSTOMER_TYPE.LEVEL && levelsLength) {
      levels = campaign.levels?.map(level => level.pk)
    }
    result['targetType'] = campaign.generalType;
    result['targetedSegments'] = segments;
    result['targetedLevels'] = levels
  }
  if (!campaign.isAlwaysActivePeriod) {
    result['endDate'] = campaign.activeEndDate;
    result['startDate'] = campaign.activeStartDate;
  } else {
    result['endDate'] = null;
    result['startDate'] = campaign.creationDate || new Date();
  }
  if (!campaign.isAlwaysVisiblePeriod) {
    result['displayEndDate'] = campaign.visibleEndDate;
    result['displayStartDate'] = campaign.visibleStartDate;
  } else {
    result['displayEndDate'] = null;
    result['displayStartDate'] = campaign.creationDate || new Date();
  }
  result['shortDescription'] = result['shortDescription'] || '';
  result['coverPhoto'] = result['coverPhoto'] || 'default.png';
  return result;
}

export const getGenerateCouponData = ({
  couponTemplateMediumType: mediumType,
  shouldUseInStore,
  couponTemplate,
}) => {
  const { couponGenerateInfo, isDifferentCodeForOnlineOffline } = couponTemplate || {}

  let createGenerateCouponImportJob = {}
  let createGenerateCouponRelated = {}

  let couponSetOnlineCouponCodeTypeField = `onlineCouponCodeType`
  let couponSetOfflineCouponCodeTypeField = `offlineCouponCodeType`
  let couponSetOfflineCouponSourceField = `offlineCouponSetType`
  const couponSetOnlineAndOfflineCouponCodeTypeField = `onlineAndOfflineCouponCodeType`
  const couponSetOnlineAndOfflineCouponSourceField = `onlineAndOfflineCouponSetType`
  if (mediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE && !isDifferentCodeForOnlineOffline) {
    couponSetOnlineCouponCodeTypeField = couponSetOnlineAndOfflineCouponCodeTypeField
    couponSetOfflineCouponCodeTypeField = couponSetOnlineAndOfflineCouponCodeTypeField
    couponSetOfflineCouponSourceField = couponSetOnlineAndOfflineCouponSourceField
  }

  const onlineCouponCodeType = couponTemplate?.[couponSetOnlineCouponCodeTypeField]
  const offlineCouponCodeType = couponTemplate?.[couponSetOfflineCouponCodeTypeField]
  const offlineCouponSetType = couponTemplate?.[couponSetOfflineCouponSourceField]


  const shouldOfflineCouponImportByFile = offlineCouponSetType === COUPON_SET_TYPES.IMPORT_EXISTING_COUPON && offlineCouponCodeType === COUPON_CODE_TYPE.UNIQUE
  const shouldOnlineCouponImportByFile = onlineCouponCodeType === COUPON_CODE_TYPE.UNIQUE

  const shouldOnlineOfflineCouponImportByFile = (
    mediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE &&
    couponTemplate?.[couponSetOnlineAndOfflineCouponCodeTypeField] === COUPON_CODE_TYPE.UNIQUE
  )

  const selectedStoresMap = couponTemplate?.selectedStores?.reduce((res, store) => {
    res[store?.pk || store?.id] = {
      ...store,
      shouldImportByFile: store?.isOnlineStore ? shouldOnlineCouponImportByFile : shouldOfflineCouponImportByFile,
    }
    return res
  }, {})


  if (shouldUseInStore) {
    let couponStoreOptions = []
    Object.entries(selectedStoresMap).forEach(([storePk, storeValue]) => {
      if (storeValue?.shouldImportByFile) {
        couponGenerateInfo?.storeImportFileMap?.[storePk] &&
          couponStoreOptions.push(
            { storeId: storePk, importFile: getFileNameFromUrl(couponGenerateInfo?.storeImportFileMap?.[storePk]) }
          )
        return
      }
      couponGenerateInfo?.inputStoreCoupon?.[storePk] && couponStoreOptions.push(
        { storeId: storePk, quantity: couponGenerateInfo?.inputStoreCoupon?.[storePk] }
      )
    })
    
    createGenerateCouponRelated = { couponStoreOptions }
    createGenerateCouponImportJob = {
      related: createGenerateCouponRelated,
    }
    return createGenerateCouponImportJob
  }

  if ((mediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE && isDifferentCodeForOnlineOffline)
    || [COUPON_SET_MEDIUM.ONLINE, COUPON_SET_MEDIUM.OFFLINE].includes(mediumType)
  ) {
    if ([COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE, COUPON_SET_MEDIUM.ONLINE].includes(mediumType)) {
      if (shouldOnlineCouponImportByFile) {
        createGenerateCouponRelated.onlineCouponImportFile = getFileNameFromUrl(
          couponGenerateInfo?.allOnlineStoreImportFile
        )
      } else {
        createGenerateCouponRelated.onlineCouponQuantity = couponGenerateInfo?.allOnlineStoreInput
      }
    }
    if ([COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE, COUPON_SET_MEDIUM.OFFLINE].includes(mediumType)) {
      if (shouldOfflineCouponImportByFile) {
        createGenerateCouponRelated.offlineCouponImportFile = getFileNameFromUrl(
          couponGenerateInfo?.allOfflineStoreImportFile
        )
      } else {
        createGenerateCouponRelated.offlineCouponQuantity = couponGenerateInfo?.allOfflineStoreInput
      }
    }
    createGenerateCouponImportJob = {
      related: createGenerateCouponRelated,
    }
    return createGenerateCouponImportJob
  }

  if (mediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE) {
    if (shouldOnlineOfflineCouponImportByFile) {
      createGenerateCouponImportJob = {
        file: getFileNameFromUrl(couponGenerateInfo?.allOnlineOfflineImport),
      }
      return createGenerateCouponImportJob
    }

    createGenerateCouponRelated.couponQuantity = couponGenerateInfo?.allOnlineOfflineInput
    createGenerateCouponImportJob = {
      related: createGenerateCouponRelated,
    }
    return createGenerateCouponImportJob
  }
  return createGenerateCouponImportJob
}

export const getCampaignCouponTemplateCreationData = (campaign, update) => {
  const campaignCouponSetFieldPrefix = couponSetFieldPrefix.endsWith(".")
    ? couponSetFieldPrefix.substring(0, couponSetFieldPrefix.length - 1)
    : couponSetFieldPrefix;
  const campaignCouponTemplate = campaign?.[campaignCouponSetFieldPrefix] || {}
  const haveCreatedCoupon = campaign?.haveCreatedCoupon
  const earningRuleRewardType = campaign?.linkedEarningRules?.rewardType
  const shouldCreateNewCouponTemplate = (campaign.campaignType === CampaignType.couponsCampaign && !haveCreatedCoupon) || (
    campaign.campaignType === CampaignType.earningRulesCampaign && earningRuleRewardType === EarningRuleRewardType.coupons && !haveCreatedCoupon
  )
  const couponTemplateData = shouldCreateNewCouponTemplate ? transformDataFromCampaignToCouponTemplate(campaign) : {}
  const createCouponTemplate = shouldCreateNewCouponTemplate
    ? cleanCouponTemplateFormData(
      couponTemplateData
      // , { pk: couponTemplateData?.pk}
    )
    : null

  const { mediumType, shouldUseInStore } = createCouponTemplate || {};

  const createGenerateCouponImportJob = getGenerateCouponData({
    couponTemplateMediumType: mediumType,
    shouldUseInStore: shouldUseInStore,
    couponTemplate: campaignCouponTemplate,
  })

  return {
    createCouponTemplate,
    createGenerateCouponImportJob
  }
}

function getDataForCreateCampaignV2(campaign, update) {
  const displayInFrontend = campaign.displayInFrontend;
  const showDisplayInFrontend = getShowDisplayInFrontend(campaign.campaignType, campaign.linkedEarningRules?.type);
  const hideInFrontend = showDisplayInFrontend && !displayInFrontend && displayInFrontend !== undefined;

  const showInOfferTab = campaign.showInOfferTab;
  const categories = showInOfferTab
    ? campaign.categories?.map((category) => category.pk)
    : [];
  let earningRule = {};
  let coupon = {};
  let task = {};
  let rewards = {};
  let icons = {};
  let ticketCampaignFields = {};
  const createCouponTemplate = getCampaignCouponTemplateCreationData(campaign)
  if (campaign.campaignType === CampaignType.couponsCampaign) {
    coupon = {
      couponCampaignTypeCouponTemplate: campaign?.linkedCoupon?.pk,
      couponCampaignTypeShouldShowCouponStock: campaign?.showCouponLimit ? campaign.displayOverLimit : false,
      couponCampaignTypeOverallLimit:
        campaign.overallLimit || (campaign.overallLimit === 0 ? 0 : null),
      couponCampaignTypePerHeadLimit: campaign?.showCouponLimit ? campaign.perHeadLimit : null,
      couponCampaignTypeRequiredPoints: campaign.requiredPoints,
    };
  }
  if (campaign.campaignType === CampaignType.earningRulesCampaign) {
    const earningRuleData = transformDataFromCampaignToEarningRule(campaign, campaign?.linkedEarningRules || {}, update);
    const earningRuleCreationData = cleanEarningRuleCreationData(earningRuleData, true, campaign?.linkedCoupon?.pk, !update);
    earningRule = {
      earningCampaignTypeEarningRule: earningRuleCreationData?.id || null,
      createOrUpdateEarningRule: earningRuleCreationData,
    }
  }
  if (campaign.campaignType === CampaignType.stampCampaign) {
    task = {
      stampTasks: campaign.stampTasks.map((stampTask, index) => {
        const earningRuleData = transformDataFromCampaignToEarningRule(campaign, stampTask || {}, update, false);
        const earningRuleCreationData = cleanEarningRuleCreationData(earningRuleData, true, null, !update);
        return {
          earningRule: earningRuleCreationData?.id || null,
          createOrUpdateEarningRule: earningRuleCreationData,
          id: stampTask.pk,
          displayOrder: index,
        }
      }),
    };
    rewards = {
      stampCampaignRewards: campaign.stampRewards.map((item) => ({
        // pk: item.pk,
        // id: item.id,
        rewardType: item.rewardType,
        quantity: item.quantity,
        requiredStamps: item.requiredStamps,
        couponTemplate:
          item.rewardType === 'COUPON' ? item.linkedCoupon?.pk : null,
      })),
    };
    if (campaign.useUploadStampIcons) {
      icons = {
        stampCampaignTypeEmptySlotStampImage:
          getImageImage(campaign.stampCampaignTypeEmptySlotStampImage) || null,
        stampCampaignTypeAcquiredStampImage:
          getImageImage(campaign.stampCampaignTypeAcquiredStampImage) || null,
        stampCampaignTypeEmptyGiftSlotImage:
          getImageImage(campaign.stampCampaignTypeEmptyGiftSlotImage) || null,
        stampCampaignTypeCollectedGiftImage:
          getImageImage(campaign.stampCampaignTypeCollectedGiftImage) || null,
      };
    } else {
      icons = {
        stampCampaignTypeEmptySlotStampImage: null,
        stampCampaignTypeAcquiredStampImage: null,
        stampCampaignTypeEmptyGiftSlotImage: null,
        stampCampaignTypeCollectedGiftImage: null,
      };
    }
  }

  if (campaign.campaignType === CampaignType.ticketCampaign) {
    ticketCampaignFields = {
      ticketCampaignTypeRequirePointsToRedeem: campaign?.requirePointsToRedeem || false,
      ticketCampaignTypeRequiredPoints: campaign?.requirePointsToRedeem ? campaign?.requiredPoints || 0 : 0,
      ticketCampaignEnableOtp: campaign?.requirePointsToRedeem || campaign?.enableOtp || false,
      ticketCampaignTypeShouldShowCouponStock: campaign.displayOverLimit,
      ticketCampaignTypePerHeadLimit: campaign.perHeadLimit || null,
      ticketCampaignShouldFillOtherInformation:
        campaign?.fillOtherInfomation || false,
      relatedTickets: getRelatedTicket(campaign),
      otherInformations: campaign?.fillOtherInfomation
        ? gerOtherInformations(campaign)
        : [],
    };
  }

  const formattedTranslation = getTranlationDataForCreateCampaign({
    campaign,
    language: LanguageConfig.english,
    update,
    hideInFrontend,
  });

  const otherTranslations = [];
  Object.keys(campaign?.translations || {}).forEach((language) => {
    if (language === LanguageConfig.english) {
      return;
    }
    otherTranslations.push(
      getTranlationDataForCreateCampaign({ campaign, language, update, hideInFrontend }),
    );
  });

  const blackoutPeriod = (campaign.activePeriodValues ?? [])
    .filter((item) => {
      return !!item?.startDate && !!item?.endDate;
    })
    .map((item) =>
      update ? item : { startDate: item.startDate, endDate: item.endDate },
    );
  const blackoutWeekday = campaign.activeWeekday;
  const isGPCampaign = campaign.campaignType === 'GENERAL_MESSAGE_CAMPAIGN';
  console.log("finallyCampaign:", campaign)
  const recurringDateInfo = campaign?.recurringDate
  if (recurringDateInfo?.pk) {
    recurringDateInfo.id = recurringDateInfo.pk
    delete recurringDateInfo.pk;
  }

  let banner = null;
  if (campaign.haveHomepageBanner) {
    banner = getBannerForCreateOrUpdate(
      getBannerDataForCampaign(campaign.banner || {}),
      true,
      false
    );
  }

  const hideInFrontendFields = {
    categories: [],
    isFeatured: false,
    brand: null,
    applyCoverPhotoToAllLanguage: false,
    applyDetailPhotosToAllLanguage: false,
    applySquareCoverPhotoToAllLanguage: false,
    malls: [],
    recurringDate: {
      ...recurringDateInfo,
      "visiblePeriodFollowBirthMonth": true,
      "visibleEndOffsetDays": null,
      "visibleEndOffsetMonths": null,
      "visibleEndDateOffsetType": "OFFSET_BY_RELATIVE_DAY",
      "visibleEndOffsetWeeks": null,
      "visibleEndSpecificDayInMonth": null,
      "visibleEndOrdinalWeekdayInMonth": null,
      "visibleEndSpecificWeekday": null,
      "visibleStartOffsetDays": null,
      "visibleStartOffsetMonths": null,
      "visibleStartDateOffsetType": "OFFSET_BY_RELATIVE_DAY",
      "visibleStartOffsetWeeks": null,
      "visibleStartSpecificDayInMonth": null,
      "visibleStartOrdinalWeekdayInMonth": null,
      "visibleStartSpecificWeekday": null,
    }
  };

  const result = {
    displayInFrontend:
      getShowDisplayInFrontend(campaign.campaignType, campaign.linkedEarningRules?.type)
        ? returnDefaultValueWhileEmpty(campaign.displayInFrontend, true)
        : true,
    type: campaign.campaignType,
    categories: categories,
    isFeatured: campaign.isFeatured || false,
    isExclusive: campaign.isExclusive || false,
    excludeBlacklistSegment: campaign?.excludeBlacklistSegment || false,
    targetedBlacklistSegments: campaign?.excludeBlacklistSegment
      ? campaign?.blacklistSegments?.map((item) => item.pk) || []
      : [],
    brand: campaign.linkedBrand?.pk || null,
    stores: campaign.linkedStores?.map((item) => item.pk),
    applyCoverPhotoToAllLanguage: campaign.applyCoverPhotoToAllLanguage,
    applyDetailPhotosToAllLanguage: campaign.applyDetailPhotosToAllLanguage,
    applySquareCoverPhotoToAllLanguage:
      campaign.applySquareCoverPhotoToAllLanguage,
    blackoutPeriod: isGPCampaign ? [] : blackoutPeriod,
    blackoutWeekday: isGPCampaign ? [] : blackoutWeekday,
    translations: otherTranslations,
    ...showCampaignPublishChannelSelector
      ? {
        publishChannel: [
          CampaignType.couponsCampaign,
          CampaignType.earningRulesCampaign,
          CampaignType.ticketCampaign,
        ].includes(campaign.campaignType)
          ? JSON.stringify(campaign.publishChannel?.map((item) => item.pk))
          : JSON.stringify(publishChannelList.map((item) => item.pk)),
      } : {},
    triggerPriority:
      campaign.campaignType === CampaignType.stampCampaign
        ? campaign.executionPriority
        : null,
    ...formattedTranslation,
    ...coupon,
    ...createCouponTemplate,
    ...earningRule,
    ...task,
    ...rewards,
    ...icons,
    ...ticketCampaignFields,
    malls: campaign.malls?.map((mall) => mall.pk) || [],
    recurringDate: recurringDateInfo,
    isBirthdayRecurringCampaign: campaign.isBirthdayRecurringCampaign,
    banner,
    ...(hideInFrontend ? hideInFrontendFields : {}),
  };

  const targetType = campaign.generalType;
  if (campaign.isExclusive && targetType) {
    let segments = [];
    let levels = [];
    const levelsLength = campaign.levels?.length;
    if (targetType === TARGET_CUSTOMER_TYPE.DYNAMIC_SEGMENT) {
      segments = campaign?.dynamicSegments?.map((segment) => segment.pk) || [];
    } else if (targetType === TARGET_CUSTOMER_TYPE.STATIC_SEGMENT) {
      segments = campaign?.staticSegments?.map((segment) => segment.pk) || [];
    } else if (targetType === TARGET_CUSTOMER_TYPE.LEVEL && levelsLength) {
      levels = campaign.levels?.map(level => level.pk)
    }
    result['targetType'] = campaign.generalType;
    result['targetedSegments'] = segments;
    result['targetedLevels'] = levels
  }
  if (!campaign.isAlwaysActivePeriod) {
    result['endDate'] = campaign.activeEndDate;
    result['startDate'] = campaign.activeStartDate;
  } else {
    result['endDate'] = null;
    result['startDate'] = campaign.creationDate || new Date();
  }
  if (!hideInFrontend && !campaign.isAlwaysVisiblePeriod) {
    result['displayEndDate'] = campaign.visibleEndDate;
    result['displayStartDate'] = campaign.visibleStartDate;
  } else {
    result['displayEndDate'] = null;
    result['displayStartDate'] = campaign.creationDate || new Date();
  }
  result['shortDescription'] = result['shortDescription'] || '';
  result['coverPhoto'] = result['coverPhoto'] || null;
  return result;
}

function getBrandSectionForCampaign(brandSection) {
  if (!brandSection) {
    return { brandSection: {}, linkedBrand: {} };
  }
  // console.log('@@247: ', brandSection);
  return {
    brandSection: {
      id: brandSection.id,
      pk: brandSection.pk,
    },
    linkedBrand: {
      id: brandSection.id,
      pk: brandSection.pk,
      name: brandSection.name,
    },
  };
}

function getCouponAndEarningRuleForCampaign(couponSection) {
  if (!couponSection) {
    return {};
  }
  return {
    id: couponSection.id,
    pk: couponSection.pk,
    name: couponSection.name,
    stock: couponSection.stock,
    totalNumberOfGeneratedCoupons: couponSection.totalNumberOfGeneratedCoupons,
    totalNumberOfAcquiredCoupons: couponSection.totalNumberOfAcquiredCoupons,
    totalNumberOfUsedCoupons: couponSection.totalNumberOfUsedCoupons,
    toDelete: couponSection.toDelete,
  };
}

function getCategoriesAndTargetGroupForCampaign(section) {
  if (!section?.edges?.length) {
    return [];
  }
  const targetGroup = section.edges.map((edge) => {
    const target = edge.node;
    if (target.levelName) {
      target.name = target.levelName
    }
    return target;
  });
  return targetGroup;
}

const getDetailPhotos = (node) => {
  const photos = [];
  if (node.detailPhoto1) {
    photos.push(addDomainToImage(node.detailPhoto1));
  }
  if (node.detailPhoto2) {
    photos.push(addDomainToImage(node.detailPhoto2));
  }

  if (node.detailPhoto3) {
    photos.push(addDomainToImage(node.detailPhoto3));
  }
  if (node.detailPhoto4) {
    photos.push(addDomainToImage(node.detailPhoto4));
  }
  return photos;
};

function translationAssemble(node, isCampaign) {
  if (!node) {
    return {};
  }
  const language = node.language || LanguageConfig.english;
  const data = {
    instructionSectionTitle: node.instructionSectionTitle,
    instructionSectionContent: node.instructionSectionContent,
    detailSectionTitle: node.detailSectionTitle,
    detailSectionContent: node.detailSectionContent,
    coverPhoto: addDomainToImage(node.coverPhoto),
    detailPhotos: getDetailPhotos(node),
    stampCampaignTypeEmptySlotStampImage: addDomainToImage(
      node.stampCampaignTypeEmptySlotStampImage,
    ),
    stampCampaignTypeAcquiredStampImage: addDomainToImage(
      node.stampCampaignTypeAcquiredStampImage,
    ),
    stampCampaignTypeEmptyGiftSlotImage: addDomainToImage(
      node.stampCampaignTypeEmptyGiftSlotImage,
    ),
    stampCampaignTypeCollectedGiftImage: addDomainToImage(
      node.stampCampaignTypeCollectedGiftImage,
    ),
  };
  if (isCampaign) {
    data.generalName = node.name;
    data.id = node.id;
    data.pk = node.pk;
    data.shortDescription = node.shortDescription;
    data.squareCoverPhoto = addDomainToImage(node.squareCoverPhoto);
  }
  return {
    [language]: data,
  };
}

function getTranslationForCampaign(campaign, isCampaign) {
  const enTranslation = translationAssemble(campaign, isCampaign);
  const chineseTranslation = campaign?.translations?.edges.map((item) => {
    return translationAssemble(item.node, isCampaign);
  });
  const reducedTranslation = chineseTranslation?.reduce(function (obj, item) {
    return {
      ...obj,
      ...item,
    };
  }, {});
  return {
    ...enTranslation,
    ...reducedTranslation,
  };
}

function getMillisecondsFromDate(date) {
  if (!date) {
    return '';
  }
  const momentTime = new Date(date);
  return momentTime;
}

function getEarningRuleForStampCampaign(stampTasks) {
  if (!stampTasks) {
    return [];
  }
  return stampTasks.map((item) => ({
    ...parseEarningRule(item.node.earningRule),
    name: item.node.earningRule?.translations?.en?.generalName || item.node.earningRule?.name
  }));
}

function getStampRewardsForCampaign(data) {
  if (!data) {
    return [[], 0];
  }
  let totalStampQuantity = 0;
  const stampRewards = data.stampRewards.edges.map((item) => {
    totalStampQuantity =
      totalStampQuantity > item.node.requiredStamps
        ? totalStampQuantity
        : item.node.requiredStamps;
    return {
      id: item.node.pk,
      rewardType: item.node.rewardType,
      requiredStamps: item.node.requiredStamps,
      quantity: item.node.quantity,
      linkedCoupon: item.node.couponTemplate,
    };
  });
  return [stampRewards, totalStampQuantity];
}

function parseTicketCampaignField(campaignData) {
  const relatedTickets = campaignData?.relatedTickets?.edges?.map((item) => {
    const translationList = item?.node?.translations?.edges?.map(
      (item) => item?.node,
    );
    const translations = translationList.reduce((dict, item) => {
      dict[item.language] = {
        timeSlot: item?.timeSlot || '',
      };
      return dict;
    }, {});
    translations[LanguageConfig.english] = {
      timeSlot: item?.node?.timeSlot || '',
    };

    return {
      ...item?.node,
      couponSet: item?.node?.couponTemplate,
      translations,
    };
  });

  const fillOtherInfomation =
    campaignData?.ticketCampaignShouldFillOtherInformation || false;

  let additionalQuestion = [];
  let showCustomerProfileFields = [];
  let showCustomerAdditionalFields = [];
  if (fillOtherInfomation) {
    const otherInformations = campaignData?.otherInformations?.edges?.map(
      (item) => item?.node,
    );
    otherInformations?.length > 0 &&
      otherInformations.forEach((info) => {
        if (
          info?.questionType ===
          TICKET_CAMPAIGN_OTHER_INFORMATION_QUESTION_TYPE.CUSTOMER_PROFILE_FIELD
        ) {
          showCustomerProfileFields.push(info?.customerProfileField);
          return;
        }
        if (
          info?.questionType ===
          TICKET_CAMPAIGN_OTHER_INFORMATION_QUESTION_TYPE.CUSTOMER_ADDITIONAL_DATA_FIELD
        ) {
          showCustomerAdditionalFields.push(info?.customerAdditionalDataField);
          return;
        }
        if (
          info?.questionType ===
          TICKET_CAMPAIGN_OTHER_INFORMATION_QUESTION_TYPE.ADDITION_QUESTION
        ) {
          const translationList = info?.translations?.edges?.map(
            (item) => item?.node,
          );
          const translations = translationList.reduce((dict, item) => {
            dict[item.language] = {
              fieldName: item?.questionNameAndHint || '',
            };
            return dict;
          }, {});
          additionalQuestion.push({
            id: info?.id,
            pk: info?.pk,
            fieldFormat: {
              label:
                DISPLAY_ADDITIONAL_FIELD_FORMAT_TYPE?.[info?.questionFormat],
              value: {
                name: DISPLAY_ADDITIONAL_FIELD_FORMAT_TYPE?.[
                  info?.questionFormat
                ],
                value: info?.questionFormat,
              },
            },
            isOptional: info?.isOptional || false,
            fieldOptions: isTicketCampaignOtherInformationQuestionShowOption({
              fieldFormat: info?.questionFormat,
            })
              ? info?.options?.edges?.map((item) => {
                const res = {
                  [LanguageConfig.english]: item?.node?.optionName,
                };
                const translationList =
                  item?.node?.translations?.edges?.map(
                    (translation) => translation.node,
                  ) || [];
                translationList.forEach(
                  (translation) =>
                    (res[translation?.language] = translation?.optionName),
                );
                return res;
              })
              : [],
            translations: {
              ...translations,
              [LanguageConfig.english]: {
                fieldName: info?.questionNameAndHint || '',
              },
            },
          });
        }
      });
  }
  return {
    requirePointsToRedeem: campaignData?.ticketCampaignTypeRequirePointsToRedeem || false,
    enableOtp: campaignData?.ticketCampaignTypeRequirePointsToRedeem || campaignData.ticketCampaignEnableOtp || false,
    fillOtherInfomation,
    ticketCampaignTimeSlots: relatedTickets,
    additionalQuestion,
    showCustomerProfileFields,
    showCustomerAdditionalFields,
  };
}

function getIconsForStampCampaign(data) {
  let useUploadStampIcons = false;
  if (data.stampCampaignTypeEmptySlotStampImage) {
    useUploadStampIcons = true;
  }
  return {
    stampCampaignTypeEmptySlotStampImage: addDomainToImage(
      data.stampCampaignTypeEmptySlotStampImage,
    ),
    useUploadStampIcons,
    stampCampaignTypeAcquiredStampImage: addDomainToImage(
      data.stampCampaignTypeAcquiredStampImage,
    ),
    stampCampaignTypeEmptyGiftSlotImage: addDomainToImage(
      data.stampCampaignTypeEmptyGiftSlotImage,
    ),
    stampCampaignTypeCollectedGiftImage: addDomainToImage(
      data.stampCampaignTypeCollectedGiftImage,
    ),
  };
}

export function getOrdinalSuffix(num) {
  if (typeof num !== 'number' || isNaN(num)) return num;

  const lastTwoDigits = num % 100;
  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return num + "th";
  }

  switch (num % 10) {
    case 1:
      return num + "st";
    case 2:
      return num + "nd";
    case 3:
      return num + "rd";
    default:
      return num + "th";
  }
}

function getStartAndEndRecurringDisplayData(prefix, recurringDate) {
  const recurringType = recurringDate[`${prefix}DateOffsetType`]
  const offsetMonths = recurringDate[`${prefix}OffsetMonths`]
  switch (recurringType) {
    case RECURRING_OFFSET_TYPE.OFFSET_BY_RELATIVE_DAY:
      const offsetDays = recurringDate[`${prefix}OffsetDays`]
      return `${offsetDays} days`
    case RECURRING_OFFSET_TYPE.OFFSET_BY_RELATIVE_MONTH:
      return `${offsetMonths} months`
    case RECURRING_OFFSET_TYPE.OFFSET_BY_RELATIVE_WEEK:
      const offsetWeeks = recurringDate[`${prefix}OffsetWeeks`]
      return `${offsetWeeks} weeks`
    case RECURRING_OFFSET_TYPE.OFFSET_DAY_IN_MONTH:
      const dayInMonth = recurringDate[`${prefix}SpecificDayInMonth`]
      const readableDayInMonth = getOrdinalSuffix(dayInMonth)
      return `${readableDayInMonth} on the ${offsetMonths} month(s)`
    case RECURRING_OFFSET_TYPE.OFFSET_WEEKDAY:
      const weekOrdinal = recurringDate[`${prefix}OrdinalWeekdayInMonth`]
      const weekday = recurringDate[`${prefix}SpecificWeekday`]
      return `${weekOrdinal} of the ${weekday} of the ${offsetMonths} month(s)`
    default:
      return "-"
  }
}

export function getDisplayRecurringPeriod({ isForBirth, recurringDate, prefix }) {
  if (!isForBirth) {
    return "-"
  }
  if (!recurringDate) {
    return "-"
  }
  const lowerCasePrefix = prefix.toLowerCase()
  const followBirthdayMonth = recurringDate[`${lowerCasePrefix}PeriodFollowBirthMonth`]
  if (followBirthdayMonth) {
    return "Follow birth month"
  }
  const recurringStartDisplay = getStartAndEndRecurringDisplayData(`${lowerCasePrefix}Start`, recurringDate)
  const recurringEndDisplay = getStartAndEndRecurringDisplayData(`${lowerCasePrefix}End`, recurringDate)
  return `${prefix} start on ${recurringStartDisplay} before the first day of the birth month - ${prefix} end on ${recurringEndDisplay} after the end day of the birth month`
}

function recurringMessageBodyCreation(campaignData, isCreateTemp) {
  if (!campaignData?.isBirthdayRecurringCampaign) {
    return null;
  };
  const values = campaignData?.recurringMessage;
  console.log("@@1049", values)
  if (!values) {
    return null;
  };
  const parsedChannels = parseChannels(values.channels || [], values.pushAndInboxSelector || MessagePushAndInboxSelector.both);

  const havePushOrInbox = (
    parsedChannels.includes(MessageBackendChannel.push)
    || parsedChannels.includes(MessageBackendChannel.inbox)
  );
  const haveEmail = parsedChannels.includes(MessageBackendChannel.email);
  const haveSms = parsedChannels.includes(MessageBackendChannel.sms);
  const haveWhatsapp = parsedChannels.includes(MessageBackendChannel.whatsapp);
  const haveWechat = parsedChannels.includes(MessageBackendChannel.wechat);

  const photo = values.translations?.[LanguageConfig.english]?.photo?.value;
  const whatsappImage =
    values.translations?.[LanguageConfig.english]?.whatsappImage?.value;

  const inputBody = {
    channels: parsedChannels,
    scheduledTime: values.scheduledTime || "00:00:00",
    sendMessageNow: values.sendMessageNow || false,
    sendToAllAgain: values.sendToAllAgain || false,

    title: values.translations?.[LanguageConfig.english]?.name || null,
    content: values.translations?.[LanguageConfig.english]?.content || null,
    photo: photo ? getFileNameFromUrl(photo) : null,
    messageLandingPageToCampaign: values.messageLandingPageToCampaign === undefined
      ? true
      : values.messageLandingPageToCampaign,

    emailTitle: values.translations?.[LanguageConfig.english]?.emailTitle || null,
    emailContent: values.translations?.[LanguageConfig.english]?.emailContent || null,

    smsContent: values.translations?.[LanguageConfig.english]?.smsContent || null,

    whatsappTemplateJson: JSON.stringify(
      values.translations?.[LanguageConfig.english]?.whatsappTemplate || {},
    ),
    whatsappTemplateName:
      values.translations?.[LanguageConfig.english]?.whatsappTemplate?.name || null,
    whatsappImage: whatsappImage ? getFileNameFromUrl(whatsappImage) : null,
    whatsappHeaderArgs:
      values.translations?.[LanguageConfig.english]?.whatsappHeader || [],
    whatsappBodyArgs:
      values.translations?.[LanguageConfig.english]?.whatsappBody || [],

    wechatTemplateJson: JSON.stringify(
      values.translations?.[LanguageConfig.english]?.wechatTemplate || {},
    ),
    wechatTemplateName:
      values.translations?.[LanguageConfig.english]?.wechatTemplate?.name || null,
    wechatBodyArgs:
      values.translations?.[LanguageConfig.english]?.wechatBody || [],
    wechatRedirectPage: values.translations?.[LanguageConfig.english]?.wechatRedirectPage,
  };

  if (!isCreateTemp) {
    inputBody["id"] = values.pk;
  }

  if (!havePushOrInbox) {
    inputBody["title"] = null;
    inputBody["content"] = null;
    inputBody["photo"] = null;
  };
  if (!haveEmail) {
    inputBody["emailTitle"] = null;
    inputBody["emailContent"] = null;
  };
  if (!haveSms) {
    inputBody["smsContent"] = null;
  };
  if (!haveWhatsapp) {
    inputBody["whatsappTemplateJson"] = JSON.stringify({});
    inputBody["whatsappTemplateName"] = null;
    inputBody["whatsappImage"] = null;
    inputBody["whatsappHeaderArgs"] = [];
    inputBody["whatsappBodyArgs"] = [];
  };
  if (!haveWechat) {
    inputBody["wechatTemplateJson"] = JSON.stringify({});
    inputBody["wechatTemplateName"] = null;
    inputBody["wechatBodyArgs"] = [];
    inputBody["wechatRedirectPage"] = null;
  };

  const translations = [];
  Object.keys(values?.translations || {}).forEach((language) => {
    if (language !== LanguageConfig.english) {
      const translationValues = values.translations?.[language];
      const translationPhoto = translationValues?.photo?.value;
      const translationWhatsappImage = translationValues?.whatsappImage?.value;
      const translationData = {
        language,

        title: translationValues?.name || null,
        content: translationValues?.content || null,
        photo: translationPhoto ? getFileNameFromUrl(translationPhoto) : null,

        emailTitle: translationValues?.emailTitle || null,
        emailContent: translationValues?.emailContent || null,

        smsContent: translationValues?.smsContent || null,

        whatsappTemplateJson: JSON.stringify(
          translationValues?.whatsappTemplate || {},
        ),
        whatsappTemplateName: translationValues?.whatsappTemplate?.name || null,
        whatsappImage: translationWhatsappImage
          ? getFileNameFromUrl(translationWhatsappImage)
          : null,
        whatsappHeaderArgs: translationValues?.whatsappHeader || [],
        whatsappBodyArgs: translationValues?.whatsappBody || [],

        wechatTemplateJson: JSON.stringify(
          translationValues?.wechatTemplate || {},
        ),
        wechatTemplateName: translationValues?.wechatTemplate?.name || null,
        wechatBodyArgs: translationValues?.wechatBody || [],
        wechatRedirectPage: translationValues?.wechatRedirectPage,
      };

      if (!isCreateTemp) {
        translationData["id"] = translationValues?.pk;
      };

      if (!havePushOrInbox) {
        translationData["title"] = null;
        translationData["content"] = null;
        translationData["photo"] = null;
      };
      if (!haveEmail) {
        translationData["emailTitle"] = null;
        translationData["emailContent"] = null;
      };
      if (!haveSms) {
        translationData["smsContent"] = null;
      };
      if (!haveWhatsapp) {
        translationData["whatsappTemplateJson"] = JSON.stringify({});
        translationData["whatsappTemplateName"] = null;
        translationData["whatsappImage"] = null;
        translationData["whatsappHeaderArgs"] = [];
        translationData["whatsappBodyArgs"] = [];
      };
      if (!haveWechat) {
        translationData["wechatTemplateJson"] = JSON.stringify({});
        translationData["wechatTemplateName"] = null;
        translationData["wechatBodyArgs"] = [];
        translationData["wechatRedirectPage"] = null;
      };

      translations.push(translationData);
    }
  });

  inputBody["translations"] = translations;
  console.log("@@1165", inputBody)
  return inputBody;
}


function assembleCampaign(
  campaign,
  customerAdditionalDataFields = null,
  homepageBanners = {},
) {
  if (!campaign) {
    return {};
  }

  // apply some save draft
  const draftData = JSON.parse(campaign.saveDraft) || {};

  [
    "activeStartDate",
    "activeEndDate",
    "visibleStartDate",
    "visibleEndDate",
  ].forEach(field => {
    if (draftData?.[field]) {
      draftData[field] = new Date(draftData[field]);
    };
  });

  const campaignData = {
    ...campaign,
    targetType: draftData?.generalType || campaign?.targetType,
  }

  campaignData.brandSection = campaignData.brand;

  let linkedCoupon = {};

  if (campaignData.type === CampaignType.couponsCampaign) {
    linkedCoupon = getCouponAndEarningRuleForCampaign(
      campaignData.couponCampaignTypeCouponTemplate,
    );
  } else if (campaignData.type === CampaignType.earningRulesCampaign) {
    const typePrefix = EarningRuleTypeKey[campaignData.earningCampaignTypeEarningRule?.type];
    linkedCoupon = getCouponAndEarningRuleForCampaign(
      campaignData?.earningCampaignTypeEarningRule?.[`${typePrefix}TypeCouponRewardTypeCouponTemplate`]
    )
  }

  const [stampRewards, totalStampQuantity] =
    getStampRewardsForCampaign(campaignData);
  let linkedEarningRules = {};
  let stampLinkedEarningRules = [];
  let couponTemplateData = {}
  if (campaignData.type === CampaignType.stampCampaign) {
    stampLinkedEarningRules = getEarningRuleForStampCampaign(
      campaignData.stampTaskRelation.edges,
    );
  } else if (campaignData.type === CampaignType.earningRulesCampaign) {
    linkedEarningRules = parseEarningRule(campaignData.earningCampaignTypeEarningRule);
    const typePrefix = EarningRuleTypeKey[campaignData.earningCampaignTypeEarningRule?.type];
    couponTemplateData = campaignData?.earningCampaignTypeEarningRule?.[`${typePrefix}TypeCouponRewardTypeCouponTemplate`]
  } else if (campaignData.type === CampaignType.couponsCampaign) {
    couponTemplateData = campaignData?.couponCampaignTypeCouponTemplate || {}
  }
  const parsedCampaignCouponTemplate = parseCouponSet(couponTemplateData)
  const campaignCouponTemplate = {
    ...parsedCampaignCouponTemplate,
    customerStoreSelectionBehavior: parsedCampaignCouponTemplate?.customerStoreSelectionBehavior
      || parsedCampaignCouponTemplate?.customerOnlineOfflineSelectionBehavior,
  }
  const icons = getIconsForStampCampaign(campaignData);
  const categories = getCategoriesAndTargetGroupForCampaign(
    campaignData.categories,
  );
  const targetType = campaignData.targetType
  const segments = getCategoriesAndTargetGroupForCampaign(
    campaignData.targetedSegments,
  );
  const dynamicSegments = targetType === TARGET_CUSTOMER_TYPE.DYNAMIC_SEGMENT ? segments : [];
  const staticSegments = targetType === TARGET_CUSTOMER_TYPE.STATIC_SEGMENT ? segments : [];
  const levels = targetType === TARGET_CUSTOMER_TYPE.LEVEL
    ? getCategoriesAndTargetGroupForCampaign(
      campaignData.targetedLevels,
    ) : [];
  const blacklistSegments = getCategoriesAndTargetGroupForCampaign(
    campaignData?.targetedBlacklistSegments,
  );
  const translations = getTranslationForCampaign(campaignData, true);
  const brandSection = getBrandSectionForCampaign(campaignData.brandSection);
  const startTime = getMillisecondsFromDate(campaignData.startDate);
  const endTime = getMillisecondsFromDate(campaignData.endDate);
  const visibleStartTime = getMillisecondsFromDate(
    campaignData.displayStartDate,
  );
  const visibleEndTime = getMillisecondsFromDate(campaignData.displayEndDate);
  const publicationTime = getMillisecondsFromDate(campaignData.publicationDate);
  const isTicketCampaign = campaignData.type === CampaignType.ticketCampaign;
  let ticketCampaignParsedField = {};
  if (isTicketCampaign) {
    ticketCampaignParsedField = parseTicketCampaignField(campaignData);
  }
  const recurringMessage = parseDetailMessage(campaignData.recurringMessage)
  console.log("recurringMessage:", recurringMessage)

  const result = {
    id: campaignData.id,
    pk: campaignData.pk,
    displayInFrontend: campaignData.displayInFrontend,
    name: campaignData.name,
    creationDate: campaignData.creationDate,
    displayCreationDate: getDetailPageDisplayLastModifiedDate(
      campaignData.creationDate,
    ),
    displayLastModifiedDate: getDetailPageDisplayLastModifiedDate(
      campaignData?.lastModifiedDate,
    ),
    displayLastModifiedBy: getDisplayLastModifiedBy(campaignData),
    campaignType: campaignData.type,
    isExclusive: campaignData.isExclusive || false,
    isFeatured: campaignData.isFeatured || false,
    isAlwaysActivePeriod: !endTime,
    activeStartDate: startTime,
    activeEndDate: endTime || startTime,
    isAlwaysVisiblePeriod: !visibleEndTime,
    activePeriodValues: campaignData.blackoutPeriod?.edges?.map((item) => {
      return {
        startDate: item.node.startDate,
        endDate: item.node.endDate,
        id: item.node.pk,
      };
    }),
    activeWeekday: campaignData.blackoutWeekday,
    visibleStartDate: visibleStartTime,
    visibleEndDate: visibleEndTime || visibleStartTime,
    publicationDate: publicationTime,
    overallLimit: isTicketCampaign
      ? campaignData.ticketCampaignTypeOverallLimit
      : campaignData.couponCampaignTypeOverallLimit,
    perHeadLimit: isTicketCampaign
      ? campaignData.ticketCampaignTypePerHeadLimit
      : campaignData.couponCampaignTypePerHeadLimit,
    requiredPoints: isTicketCampaign
      ? campaignData.ticketCampaignTypeRequiredPoints
      : campaignData.couponCampaignTypeRequiredPoints,
    displayOverLimit: isTicketCampaign
      ? campaignData.ticketCampaignTypeShouldShowCouponStock
      : campaignData.couponCampaignTypeShouldShowCouponStock || false,
    isPublished: campaignData.isPublished,
    linkedBrand: brandSection.linkedBrand,
    brandSection: brandSection,
    linkedStores: campaignData.stores?.edges?.map((item) => item.node),
    haveHomepageBanner: homepageBanners?.edges?.length > 0,
    banner: assembleDetailBanner(homepageBanners?.edges?.[0]?.node, []),
    linkedEarningRules,
    haveCreatedCoupon: !!couponTemplateData?.pk,
    showCouponLimit: isTicketCampaign ?
      false
      : campaignData.couponCampaignTypeShouldShowCouponStock || !!campaignData?.couponCampaignTypePerHeadLimit,
    campaignCouponTemplate,
    stampLinkedEarningRules,
    stampTasks: stampLinkedEarningRules,
    linkedCoupon,
    showInOfferTab: categories?.length > 0,
    categories,
    translations,
    generalType: targetType,
    dynamicSegments,
    staticSegments,
    segments: segments || [],
    levels: levels || [],
    excludeBlacklistSegment: campaignData?.excludeBlacklistSegment || false,
    blacklistSegments,
    typeDisplay: getTypeDisplay(campaignData.type),
    order: campaignData.displayPriority,
    applyCoverPhotoToAllLanguage: campaignData.applyCoverPhotoToAllLanguage,
    applyDetailPhotosToAllLanguage: campaignData.applyDetailPhotosToAllLanguage,
    applySquareCoverPhotoToAllLanguage:
      campaignData.applySquareCoverPhotoToAllLanguage,
    stampRewards,
    totalStampQuantity,
    approvalStatus: campaignData.approvalStatus,
    publishChannel: publishChannelList.filter(({ pk }) =>
      JSON.parse(campaignData.publishChannel)?.includes(pk),
    ),
    displayStatus: getFormatedStatus(campaignData),
    executionPriority: campaignData.triggerPriority,
    ...ticketCampaignParsedField,
    ...icons,
    malls: campaignData.malls?.edges?.map((item) => (item.node)),
    recurringMessage: recurringMessage,
    isBirthdayRecurringCampaign: campaignData.isBirthdayRecurringCampaign,
    recurringDate: campaignData.recurringDate,
    otherInformations: getOtherInformationsForInputValue(
      campaignData,
      customerAdditionalDataFields,
    ),
  }

  // apply all save draft
  return {
    ...result,
    ...draftData,
  };
}

const campaignInit = () => ({
  id: null,
  pk: null,
  applyCoverPhotoToAllLanguage: false,
  applyDetailPhotosToAllLanguage: false,
  applySquareCoverPhotoToAllLanguage: false,
  isExclusive: false,
  creationDate: null,
  isFeatured: false,
  campaignType: '',
  isAlwaysActivePeriod: false,
  activeStartDate: null,
  activeEndDate: null,
  isAlwaysVisiblePeriod: false,
  visibleStartDate: null,
  visibleEndDate: null,
  overallLimit: null,
  perHeadLimit: null,
  requiredPoints: 0,
  displayOverLimit: false,
  linkedCoupon: null,
  linkedBrand: null,
  order: null,
  typeDisplay: null,
  categories: [],
  customerGroup: [],
  segments: [],
  generalType: TARGET_CUSTOMER_TYPE.DYNAMIC_SEGMENT,
  translations: {},
  linkedEarningRules: {},
  stampLinkedEarningRules: [],
  stampTasks: [],
  stampRewards: [{}],
  useUploadStampIcons: false,
  totalStampQuantity: 0,
  enableOtp: false, // for ticket campaign
  ticketCampaignTimeSlots: [],
  fillOtherInfomation: false,
  executionPriority: null,
});

const getInitialState = () => ({
  campaign: campaignInit(),
  hasUpdatedDefaultValues: false,
  formHasSubmitted: false,
  errorFields: [],
  errorSectionList: [],
  stepConfig: defaultStep(stepNames),
  stampStepConfig: defaultStep(stampStepNames),
  generalMessageStepConfig: defaultStep(generalMessageStepNames),
  currentStep: 0,
  languageTag: LanguageConfig.english,
  createStatus: APIStatus.none,
  campaignPublish: APIStatus.none,
  detailLoading: APIStatus.none,
});


export default createModel({
  namespace: 'createCampaign',
  state: getInitialState(),

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },

    updateCampaign(state, { payload }) {
      console.log('@722 update campaign', payload);
      const campaign = { ...state.campaign, ...payload };
      // saveToSessionStorage(sessionDataKey.objectKey, campaign);
      // saveDataToSessions(campaign);
      return { ...state, campaign: campaign };
    },

    assembleCampaign(state, { payload }) {
      const campaignData = assembleCampaign(
        payload.campaign,
        payload.customerAdditionalDataFields,
        payload.homepageBanners,
      );
      console.log("@@1219", campaignData)

      const { homepageBanners } = payload;
      const startDateList = homepageBanners?.edges
        ?.map((item) => item.node.visiblePeriodStartDate)
        ?.filter((item) => !!item);
      const relatedBannerStartDate = startDateList?.toSorted(
        (a, b) => new Date(b).getTime() - new Date(a).getTime(),
      )?.[0];
      const endDateList = homepageBanners?.edges
        ?.map((item) => item.node.visiblePeriodEndDate)
        ?.filter((item) => !!item);
      const relatedBannerEndDate = endDateList?.toSorted(
        (a, b) => new Date(a).getTime() - new Date(b).getTime(),
      )?.[0];
      console.log('kevin@984', homepageBanners);
      console.log(startDateList);
      console.log(relatedBannerStartDate);
      console.log(endDateList);
      console.log(relatedBannerEndDate);
      const campaign = {
        ...state.campaign,
        ...campaignData,
        relatedBannerCount: homepageBanners?.totalCount || 0,
        relatedBannerFirstOne: homepageBanners?.edges?.[0]?.node,
        relatedBannerStartDate,
        relatedBannerEndDate,
        translations: {
          ...state.campaign?.translations,
          ...campaignData.translations,
        },
      };
      // saveToSessionStorage(sessionDataKey.origionalData, campaign);
      // saveToSessionStorage(sessionDataKey.objectKey, campaign);
      // saveDataToSessions(campaign);
      return {
        ...state,
        campaign: campaign,
        hasUpdatedDefaultValues: true,
      };
    },

    loadCampaignFromCookie(state, { payload }) {
      const isStamp = payload?.isStamp;
      const campaignType = payload?.campaignType;
      let objKey = sessionDataKey.objectKey
      if (isStamp) {
        objKey = stampSessionDataKey.objectKey
      } else if (campaignType === CampaignType.generalMessageCampaign) {
        objKey = generalMessageCampaignSessionDataKey.objectKey
      }
      const campaign = payload.resume
        ? getObjectFromSessionStorage(objKey) || campaignInit()
        : campaignInit();
      console.log('791', campaign);
      // if (!campaign) {
      //   return {
      //     ...state,
      //   };
      // }
      if (campaign?.pk) {
        removeDataFromSessionStorage(payload?.isStamp, campaignType);
      }

      console.log('@815', payload);
      return {
        ...state,
        campaign: campaign,
        hasUpdatedDefaultValues: true,
      };
    },

    // saveOrRemoveCampaignFromCookie(state, { payload }) {
    //   if (!payload) {
    //     removeFromSessionStorage(sessionDataKey.objectKey);
    //   }
    //   saveToSessionStorage(sessionDataKey.stepEndKey, true);
    //   return {
    //     ...state,
    //   };
    // },

    stepChange(state, { payload }) {
      const isBack = payload.isBack;
      // const data = payload.data;
      let step = payload.step;
      const isValid = payload.isValid;
      const isStamp = payload.isStamp;

      const stepConfig = isStamp
        ? getNewStepConfig(step, state.stampStepConfig, !isValid, isBack)
        : getNewStepConfig(step, state.stepConfig, !isValid, isBack);

      if (isValid) {
        step = isBack ? step - 1 : step + 1;
      }
      return {
        ...state,
        currentStep: step,
        stepConfig,
        createStatus: APIStatus.none,
      };
    },
    clearData(state, { payload }) {
      if (payload?.deleteSession) {
        removeDataFromSessionStorage();
      }
      localStorage.removeItem(LINK_COUPON_STRING);
      console.log('@873', payload);
      return { ...state, ...getInitialState() };
    },
    updateEarningRuleProducts(state, { payload }) {
      const page = payload.page;
      const specialSkus = payload.specialSkus;
      const inputSkus = payload.inputSkus;

      return {
        ...state,
        campaign: {
          ...state.campaign,
          linkedEarningRules: {
            ...state.campaign.linkedEarningRules,
            specialSkus: page > 1 ? [...state.campaign.linkedEarningRules?.specialSkus, ...specialSkus] : specialSkus,
            inputSkus: page > 1 ? [...state.campaign.linkedEarningRules?.inputSkus, ...inputSkus] : inputSkus,
          }
        }
      }
    },
  },

  effects: {
    updateApprovalStatus: [
      function* ({ payload }, { all, select, put }) {
        const afterAction = payload.afterAction || (() => { });
        const campaignPk = payload.data?.pk;

        const input = { id: campaignPk };
        if (
          payload.actionType === ActionType.unpublish
          && payload.deleteBanner
          && payload.data?.banner?.pk
        ) {
          input["bannerToDelete"] = payload.data?.banner?.pk;
        };

        let serviceArgs = [
          updateApprovalStatus,
          input,
          payload.data?.approvalStatus,
          payload.actionType,
        ];
        function* onSuccess(data) {
          console.log('@1295', data);
          yield all([
            put({
              type: 'updateState',
              payload: {
                createStatus: APIStatus.success,
                campaignPublish:
                  payload.actionType === ActionType.publish
                    ? APIStatus.success
                    : APIStatus.none,
                formHasSubmitted: true,
              },
            }),
          ]);
          afterAction();
        }

        function* onError(response) {
          yield put({
            type: 'updateState',
            payload: {
              createStatus: APIStatus.failed,
              campaignPublish: APIStatus.failed,
            },
          });
          afterAction();
        }

        yield apiWithResponseHandle(serviceArgs, onSuccess, onError, onError);
      },
    ],

    createOrUpdateCampaign: [
      function* ({ payload }, { call, select, put, all }) {
        const resume = payload.resume || false;
        const isStamp = payload.isStamp || false;
        yield put({
          type: 'updateState',
          payload: { createStatus: APIStatus.calling },
        });
        saveToSessionStorage(
          isStamp ? stampSessionDataKey.stepEndKey : sessionDataKey.stepEndKey,
          true,
        );
        const { modelCampaign } = yield select((state) => ({
          modelCampaign: state.createCampaign.campaign,
        }));
        console.log('@1135 payload', payload);
        const originalCampaign = payload?.data || modelCampaign;
        let campaignData = {};
        console.log('@1141 originalCampaign', originalCampaign);
        campaignData = getDataForCreateCampaign(
          originalCampaign,
          payload.actionType === ActionType.tempForPulished
            ? false
            : originalCampaign.pk,
        );
        const isCreateTemp = payload.actionType === ActionType.tempForPulished;

        console.log("createOrUpdateCampaign:", originalCampaign)
        campaignData.recurringMessage = recurringMessageBodyCreation(originalCampaign, isCreateTemp)
        console.log('@1145', campaignData);
        let serviceArgs = [createCampaign, campaignData];
        if (isCreateTemp) {
          campaignData.originCampaign = originalCampaign.pk;
          // when create temp campaign, delete id
          delete campaignData.recurringDate?.id;

          campaignData.translations = campaignData.translations?.map((item) => {
            delete item.id;
            return {
              ...item,
            };
          });
          serviceArgs = [CreateTempCampaign, campaignData];
        } else if (originalCampaign.pk) {
          campaignData.id = originalCampaign.pk;
          serviceArgs = [updateCampaign, campaignData];
        }
        function* onSuccess(data) {
          if (resume) {
            removeDataFromSessionStorage(isStamp);
          }
          console.log('@1173', data);
          const campaign =
            data[
              `${originalCampaign.pk
                ? payload.actionType === ActionType.tempForPulished
                  ? 'createTemp'
                  : 'update'
                : 'create'
              }Campaign`
            ].node;
          if (!campaign) {
            yield put({
              type: 'updateState',
              payload: {
                createStatus: APIStatus.failed,
              },
            });
            return;
          }
          const needUpdateApprovalStatus =
            payload.actionType !== undefined &&
            payload.actionType !== ActionType.update &&
            payload.actionType !== ActionType.save &&
            payload.actionType !== ActionType.tempForPulished;

          yield all([
            put({
              type: 'updateState',
              payload: {
                apiError: false,
                createStatus: APIStatus.success,
                ...(needUpdateApprovalStatus
                  ? null
                  : { formHasSubmitted: true }),
              },
            }),
            put({
              type: 'getOneCampaign',
              payload: {
                id: campaign.pk,
              },
            }),
            needUpdateApprovalStatus &&
            put({
              type: 'updateApprovalStatus',
              payload: {
                ...payload,
                data: {
                  pk: campaign.pk,
                  approvalStatus: campaign.approvalStatus,
                },
                actionType: payload?.actionType,
                otaAllocationNum: payload.otaAllocatedNum,
              },
            }),
          ]);
        }
        function* failed(data) {
          console.log('createOneCampaign failed:', data);
          yield put({
            type: 'updateState',
            payload: {
              apiError: true,
              createStatus: APIStatus.failed,
            },
          });
        }

        yield apiWithResponseHandle(serviceArgs, onSuccess, failed, failed);
      },
      { type: 'takeLatest' },
    ],

    createOrUpdateCampaignV2: [
      function* ({ payload }, { call, select, put, all }) {
        const resume = payload.resume || false;
        const isStamp = payload.isStamp || false;
        yield put({
          type: 'updateState',
          payload: { createStatus: APIStatus.calling },
        });
        saveToSessionStorage(
          isStamp ? stampSessionDataKey.stepEndKey : sessionDataKey.stepEndKey,
          true,
        );
        const { modelCampaign } = yield select((state) => ({
          modelCampaign: state.createCampaign.campaign,
        }));
        console.log('@1135 payload', payload);
        const originalCampaign = payload?.data || modelCampaign;
        let campaignData = {};
        console.log('@1141 originalCampaign', originalCampaign);
        campaignData = getDataForCreateCampaignV2(
          originalCampaign,
          payload.actionType === ActionType.tempForPulished
            ? false
            : originalCampaign.pk,
        );
        const isCreateTemp = payload.actionType === ActionType.tempForPulished;

        console.log("createOrUpdateCampaign:", originalCampaign)
        campaignData.recurringMessage = recurringMessageBodyCreation(originalCampaign, isCreateTemp)

        // save draft data
        const originalCampaignData = JSON.parse(JSON.stringify(originalCampaign));

        if (isCreateTemp) {
          // when create temp campaign, delete id
          // delete originalCampaignData?.linkedEarningRules?.pk;
          // delete originalCampaignData?.linkedEarningRules?.recurringDate?.pk;
          delete originalCampaignData?.banner?.pk;
          delete originalCampaignData?.recurringDate?.pk;
          delete originalCampaignData?.recurringDate?.id;
          delete originalCampaignData?.recurringMessage?.pk;

          for (const [languageCode, translation] of Object.entries(originalCampaignData?.translations || {})) {
            delete translation.pk;
          }
          for (const [languageCode, translation] of Object.entries(originalCampaignData?.recurringMessage?.translations || {})) {
            delete translation.pk;
          }
          for (const lineItemGroup of (originalCampaignData.linkedEarningRules?.lineItemGroups || [])) {
            delete lineItemGroup?.pk;
          }

          originalCampaignData.approvalStatus = ApprovalStatus.draft;
        }

        const campaignDraftData = {};

        [
          "name",
          "type",
          "categories",
          "targetedSegments",
          "targetedLevels",
          "excludeBlacklistSegment",
          "targetedBlacklistSegments",
          "brand",
          "stores",
          "malls",
        ].forEach(field => {
          campaignDraftData[field] = campaignData[field];
        });

        [
          "id",
          "pk",
          "approvalStatus",
          "categories",
          "dynamicSegments",
          "staticSegments",
          "levels",
          "excludeBlacklistSegment",
          "blacklistSegments",
          "linkedBrand",
          "linkedStores",
          "malls",
        ].forEach(field => {
          delete originalCampaignData[field]
        });
        campaignDraftData.saveDraft = JSON.stringify(originalCampaignData)

        console.log('@@1145', campaignData);
        console.log("@@1146", campaignDraftData);
        let serviceArgs = [createDraftCampaign, campaignDraftData];
        if (isCreateTemp) {
          campaignDraftData.originCampaign = originalCampaign.pk;
          serviceArgs = [CreateTempCampaignV2, campaignDraftData];
        } else if (originalCampaign.pk) {
          campaignDraftData.id = originalCampaign.pk;
          serviceArgs = [updateDraftCampaign, campaignDraftData];
        }
        function* onSuccess(data) {
          if (resume) {
            removeDataFromSessionStorage(isStamp);
          }
          console.log('@1173', data);
          const campaign =
            data[
              `${originalCampaign.pk
                ? payload.actionType === ActionType.tempForPulished
                  ? 'createTempCampaignV2'
                  : 'updateDraftCampaign'
                : 'createDraftCampaign'
              }`
            ].node;
          if (!campaign) {
            yield put({
              type: 'updateState',
              payload: {
                createStatus: APIStatus.failed,
              },
            });
            return;
          }
          const needUpdateApprovalStatus =
            payload.actionType !== undefined &&
            payload.actionType !== ActionType.update &&
            payload.actionType !== ActionType.save &&
            payload.actionType !== ActionType.tempForPulished;

          yield all([
            put({
              type: 'updateState',
              payload: {
                apiError: false,
                createStatus: APIStatus.success,
                ...(needUpdateApprovalStatus
                  ? null
                  : { formHasSubmitted: true }),
              },
            }),
            !isCreateTemp && put({
              type: 'getOneCampaign',
              payload: {
                id: campaign.pk,
              },
            }),
            needUpdateApprovalStatus &&
            put({
              type: 'updateApprovalStatus',
              payload: {
                ...payload,
                data: {
                  pk: campaign.pk,
                  approvalStatus: campaign.approvalStatus,
                },
                actionType: payload?.actionType,
                otaAllocationNum: payload.otaAllocatedNum,
              },
            }),
          ]);
        }
        function* failed(data) {
          console.log('createOneCampaign failed:', data);
          yield put({
            type: 'updateState',
            payload: {
              apiError: true,
              createStatus: APIStatus.failed,
            },
          });
        }

        yield apiWithResponseHandle(serviceArgs, onSuccess, failed, failed);
      },
      { type: 'takeLatest' },
    ],

    // create a draft campaign, set id in campaign data
    prePublishCampaign: [
      function* ({ payload }, { call, select, put, all }) {
        console.log('@@1540 payload', payload);
        yield put({
          type: 'updateState',
          payload: { createStatus: APIStatus.calling },
        });

        const campaign = getDataForCreateCampaignV2(
          payload.data,
          false,
        );
        const campaignDraftData = {
          "name": campaign.name,
          "type": campaign.type,
          "saveDraft": JSON.stringify({}),
        };

        let serviceArgs = [
          createDraftCampaign,
          campaignDraftData,
        ];


        function* onSuccess(data) {
          console.log('@@prePublishCampaign success', data);
          yield put({
            type: 'publishCampaignV2',
            payload: {
              ...payload,
              data: {
                ...payload.data,
                pk: data.createDraftCampaign.node.pk,
              }
            },
          })
        }
        function* failed(data) {
          console.log('@@prePublishCampaign failed:', data);
          yield put({
            type: 'updateState',
            payload: {
              apiError: true,
              createStatus: APIStatus.failed,
            },
          });
        }

        yield apiWithResponseHandle(serviceArgs, onSuccess, failed, failed);
      },
      { type: 'takeLatest' },
    ],

    publishCampaignV2: [
      function* ({ payload }, { call, select, put, all }) {
        const resume = payload.resume || false;
        const isStamp = payload.isStamp || false;
        yield put({
          type: 'updateState',
          payload: { createStatus: APIStatus.calling },
        });
        saveToSessionStorage(
          isStamp ? stampSessionDataKey.stepEndKey : sessionDataKey.stepEndKey,
          true,
        );
        const { modelCampaign } = yield select((state) => ({
          modelCampaign: state.createCampaign.campaign,
        }));
        console.log('@1506 payload', payload);
        const originalCampaign = payload?.data || modelCampaign;
        let campaignData = {};
        console.log('@1509 originalCampaign', originalCampaign);
        campaignData = getDataForCreateCampaignV2(
          originalCampaign,
          originalCampaign.pk,
        );

        campaignData.recurringMessage = recurringMessageBodyCreation(originalCampaign, false);
        campaignData.saveDraft = JSON.stringify({});

        if (originalCampaign.pk) {
          campaignData.id = originalCampaign.pk;
        };

        const earningRuleCreationData = campaignData.createOrUpdateEarningRule;
        console.log('@@1527', campaignData);
        console.log("@@1528", earningRuleCreationData);

        let serviceArgs = [
          publishCampaignV2,
          campaignData
        ];

        if (campaignData.earningCampaignTypeEarningRule) {
          serviceArgs = [
            publishCampaignWithExistEarningRule,
            campaignData,
            earningRuleCreationData
          ]
          delete campaignData.createOrUpdateEarningRule;
        }

        function* onSuccess(data) {
          if (resume) {
            removeDataFromSessionStorage(isStamp);
          }
          console.log('@1527', data);
          yield all(
            [
              put({
                type: 'updateCampaign',
                payload: {
                  pk: campaignData?.id,
                },
              }),
              put({
                type: 'updateState',
                payload: {
                  apiError: false,
                  createStatus: APIStatus.success,
                  formHasSubmitted: true,
                },
              })
            ]
          )
        }
        function* failed(data) {
          console.log('@@publishCampaign failed:', data);
          yield put({
            type: 'updateState',
            payload: {
              apiError: true,
              createStatus: APIStatus.failed,
            },
          });
        }

        yield apiWithResponseHandle(serviceArgs, onSuccess, failed, failed);
      },
      { type: 'takeLatest' },
    ],


    createCampaigncategory: [
      function* ({ payload }, { call, all, put, race, take }) {
        const {
          enCategory,
          simpleCategory,
          traditionalCategory,
          priority,
          successAction,
        } = payload;

        yield put(
          createAction('createCampaignCategory/createCampaignCategory')({
            enCategory,
            translations: {
              [LanguageConfig.simplifiedChinese]: {
                name: simpleCategory,
              },
              [LanguageConfig.traditionalChinese]: {
                name: traditionalCategory,
              },
            },
            priority,
            isForcedInactive: false,
            successAction,
          }),
        );
        // eslint-disable-next-line no-unused-vars
        const [success, failed] = yield race([
          take(CREATE_CAMPAIGN_CATEGORY_SUCCESS),
          take(CREATE_CAMPAIGN_CATEGORY_FAILD),
        ]);
        if (success) {
          yield put(
            createAction('campaignCategoryList/getCampaignCategoryList')({
              status: true,
            }),
          );
        }
      },
      { type: 'takeLatest' },
    ],

    getOneCampaign: [
      function* ({ payload }, { all, select, put }) {
        if (!payload?.id) {
          return;
        }
        yield put({
          type: 'updateState',
          payload: {
            createStatus: APIStatus.calling,
            detailLoading: APIStatus.calling,
          },
        });

        const customerAdditionalDataFields = yield select(
          (state) => state.customerList.additionalDataFieldValues,
        );

        const id = convertPKToId('CampaignNode', payload.id);
        const serviceArgs = [getCampaign, id, payload.id];
        function* onSuccess(data) {
          console.log('getOneCampaign onSuccess :', data);
          yield all([
            put({
              type: 'assembleCampaign',
              payload: {
                campaign: data.campaign,
                homepageBanners: data?.homepageBanners,
                isDetail: payload.isDetail,
                newItems: payload,
                customerAdditionalDataFields,
              },
            }),
            put({
              type: 'updateState',
              payload: { createStatus: APIStatus.success },
            }),
          ]);

          const earningRuleId = data.campaign?.earningCampaignTypeEarningRule?.pk;
          if (earningRuleId) {
            yield put({
              type: 'createEarningRules/getEarningRuleProducts',
              payload: {
                earningRuleId,
                isCampaignStreamLine: true,
              }
            })
          }
        }
        function* onError(err) {
          console.log('getOneCampaign onError :', err);
          yield put({
            type: 'updateState',
            payload: { createStatus: APIStatus.failed },
          });
        }
        function* onArgumentsError(err) {
          console.log('getOneCampaign arguments error :', err);
          yield put({
            type: 'updateState',
            payload: { createStatus: APIStatus.failed },
          });
        }
        yield apiWithResponseHandle(
          serviceArgs,
          onSuccess,
          onError,
          onArgumentsError,
        );
        yield put({
          type: 'updateState',
          payload: { detailLoading: APIStatus.none },
        });
      },
      { type: 'takeLatest' },
    ],
    deleteCampaigns: [
      function* ({ payload }, { call, select, put }) {
        const selectedCampaignIds = yield select(
          (state) => state.campaignList.checkedList,
        );
        const deleteCampaignIds = selectedCampaignIds?.map((item) => item.pk);
        console.log('@1344', deleteCampaignIds);
        const afterAction = payload.afterAction || (() => { });
        yield call(deleteCampaign, deleteCampaignIds);
        yield delay(1000);
        afterAction();
      },
      { type: 'takeLatest' },
    ],

    duplicateCampaign: [
      function* ({ payload }, { call, select, put }) {
        const campaignId = payload.campaignId;

        yield put.resolve({
          type: 'createCampaign/getOneCampaign',
          payload: { id: campaignId },
        });

        const { originalCampaign } = yield select((state) => ({
          originalCampaign: state.createCampaign.campaign,
        }));

        console.log("@@2464", originalCampaign)
        const campaignData = getDataForCreateCampaignV2(
          originalCampaign,
          false,
        );

        campaignData.recurringMessage = recurringMessageBodyCreation(originalCampaign, true)

        // save draft data
        const originalCampaignData = JSON.parse(JSON.stringify(originalCampaign));

        // when duplicate campaign, delete id
        delete originalCampaignData?.linkedEarningRules?.pk;
        delete originalCampaignData?.linkedEarningRules?.recurringDate?.pk;
        delete originalCampaignData?.banner?.pk;
        delete originalCampaignData?.recurringDate?.pk;
        delete originalCampaignData?.recurringDate?.id;
        delete originalCampaignData?.recurringMessage?.pk;

        for (const [languageCode, translation] of Object.entries(originalCampaignData?.translations || {})) {
          delete translation.pk;

          if (languageCode === LanguageConfig.english) {
            translation.generalName = `Copy of ${translation.generalName}`;
          };
        }

        for (const [languageCode, translation] of Object.entries(originalCampaignData?.recurringMessage?.translations || {})) {
          delete translation.pk;
        }

        for (const lineItemGroup of (originalCampaignData.linkedEarningRules?.lineItemGroups || [])) {
          delete lineItemGroup?.pk;
        }

        originalCampaignData.stampLinkedEarningRules = []
        for (const stampTask of (originalCampaignData?.stampTasks || [])) {
          stampTask.lindedStampCampaigns = [];
          delete stampTask?.pk;
          delete stampTask?.id;
          delete stampTask?.recurringDate?.pk;
          delete stampTask?.recurringDate?.id;
          for (const translation of Object.values(stampTask?.translations || {})) {
            delete translation.pk;
            delete translation.id;
          }
        }

        originalCampaignData.approvalStatus = ApprovalStatus.draft;

        const campaignDraftData = {};

        campaignData["name"] = `Copy of ${campaignData["name"]}`;

        [
          "name",
          "type",
          "categories",
          "targetedSegments",
          "targetedLevels",
          "excludeBlacklistSegment",
          "targetedBlacklistSegments",
          "brand",
          "stores",
          "malls",
        ].forEach(field => {
          campaignDraftData[field] = campaignData[field];
        });

        [
          "id",
          "pk",
          "approvalStatus",
          "categories",
          "dynamicSegments",
          "staticSegments",
          "levels",
          "excludeBlacklistSegment",
          "blacklistSegments",
          "linkedBrand",
          "linkedStores",
          "malls",
        ].forEach(field => {
          delete originalCampaignData[field]
        });

        console.log("@@2521", originalCampaignData)

        campaignDraftData.saveDraft = JSON.stringify(originalCampaignData)

        const serviceArgs = [createDraftCampaign, campaignDraftData];
        const afterAction = payload.afterAction || (() => { });
        function* onSuccess() {
          yield afterAction();
        }
        yield loading(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],

    getAndLinkCouponDetail: [
      function* ({ payload }, { call, select, put }) {
        if (!payload.couponId) {
          return;
        }

        const couponId = convertPKToId('CouponTemplateNode', payload.couponId);
        const linkedCoupon = yield select(
          (state) => state.createCampaign.campaign.linkedCoupon,
        ) || {};
        const afterAction = payload?.afterAction || (() => { });
        const serviceArgs = [getOneCoupon, couponId];
        // eslint-disable-next-line require-yield
        function* onSuccess(data) {
          const onlyEnCouponTemplate = { ...data.couponTemplate };
          delete onlyEnCouponTemplate['translations'];

          const scCouponTemplate =
            data.couponTemplate.translations.edges.filter(
              (item) => item.node.language === LanguageConfig.simplifiedChinese,
            )?.[0]?.node;
          const tcCouponTemplate =
            data.couponTemplate.translations.edges.filter(
              (item) =>
                item.node.language === LanguageConfig.traditionalChinese,
            )?.[0]?.node;
          afterAction({
            linkedCoupon: {
              ...linkedCoupon,
              ...data.couponTemplate,
              translations: {
                [LanguageConfig.english]: {
                  ...onlyEnCouponTemplate,
                  generalName: onlyEnCouponTemplate?.name,
                },
                [LanguageConfig.simplifiedChinese]: {
                  ...scCouponTemplate,
                  generalName: scCouponTemplate?.name,
                },
                [LanguageConfig.traditionalChinese]: {
                  ...tcCouponTemplate,
                  generalName: tcCouponTemplate?.name,
                },
              },
            },
          });
        }
        yield apiWithResponseHandle(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],

    getAndLinkEarningRuleDetail: [
      function* ({ payload }, { call, select, put }) {
        if (!payload.earningRuleId) {
          return;
        }
        const earningRuleId = convertPKToId(
          'EarningRuleNode',
          payload.earningRuleId,
        );
        const linkedEarningRules = yield select(
          (state) => state.createCampaign.campaign.linkedEarningRules,
        ) || {};
        const serviceArgs = [getOneEarningRule, earningRuleId];
        const afterAction = payload?.afterAction || (() => { });
        function* onSuccess(data) {
          const onlyEnEarnRule = { ...data.earningRule };
          delete onlyEnEarnRule['translations'];

          const scEarnRule = data.earningRule?.translations.edges.filter(
            (item) => item.node.language === LanguageConfig.simplifiedChinese,
          )?.[0]?.node;
          const tcEarnRule = data.earningRule?.translations.edges.filter(
            (item) => item.node.language === LanguageConfig.traditionalChinese,
          )?.[0]?.node;

          yield afterAction({
            linkedEarningRules: {
              ...linkedEarningRules,
              ...data.earningRule,
              translations: {
                [LanguageConfig.english]: {
                  ...onlyEnEarnRule,
                  generalName: onlyEnEarnRule?.name,
                },
                [LanguageConfig.simplifiedChinese]: {
                  ...scEarnRule,
                  generalName: scEarnRule?.name,
                },
                [LanguageConfig.traditionalChinese]: {
                  ...tcEarnRule,
                  generalName: tcEarnRule?.name,
                },
              },
            },
          });
        }
        yield apiWithResponseHandle(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],

    rejectCampaign: [
      function* ({ payload }, { all, put }) {
        const { id, message } = payload;
        const afterAction = payload.afterAction || (() => { });
        const serviceArgs = [rejectPendingForApprovalCampaign, { id, message }];
        function* onSuccess(data) {
          yield all([
            put({
              type: 'updateState',
              payload: {
                createStatus: APIStatus.success,
                formHasSubmitted: true,
              },
            }),
          ]);
          afterAction();
        }

        function* onError(response) {
          yield put({
            type: 'updateState',
            payload: {
              createStatus: APIStatus.failed,
              formHasSubmitted: true,
            },
          });
          afterAction();
        }

        yield apiWithResponseHandle(serviceArgs, onSuccess, onError, onError);
      },
      { type: 'takeLatest' },
    ],
  },
});